// TODO: Convert to a component.

import React, { useState } from 'react';
import clsx from 'clsx';
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  makeStyles
} from '@material-ui/core';
import { CustomInputEvent, CustomKeyboardEvent } from 'src/types';
import { slices, useAppDispatch } from 'src/redux';
import { usePermissions, useSnackBar } from 'src/hooks';
// import FormAddDialog from 'src/components/dialogs/FormDialog';
import { unwrapResult } from '@reduxjs/toolkit';
import { containsAlphabetsWithSpacesAndDashes } from 'src/utils';
import {
  Contact,
  SupplierCompanyDetailRequest
} from 'src/types/supplier';
import useResolution from 'src/hooks/useResolution';
import SupplierDialogForm from './components/SupplierDialogForm';

const { actions: supplierActions } = slices.supplier;

interface Props {
  className?: string;
  setSearchText: (text: string) => void;
  getSupplierData: () => void;
}

const useStyles = makeStyles((theme) => ({
  root: {},
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  cardContent: {
    flexDirection: 'row'
  },
  supplyicon: {
    backgroundImage: 'url(/static/images/icons/supply.png)',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    width: 20,
    height: 20,
    marginRight: 8
  }
}));

const Toolbar = ({
  className,
  getSupplierData,
  setSearchText,
  ...rest
}: Props) => {
  const classes = useStyles();
  const snackBar = useSnackBar();
  const dispatch = useAppDispatch();
  const { canAddSuppliers } = usePermissions();
  const { sm, md } = useResolution();

  const [isCreateSupplierVisible, setIsCreateSupplierVisible] = useState<
    boolean
  >(false);
  const [addSupplierLoading, setAddSupplierLoading] = useState<boolean>(false);

  const onOpenCreateSupplierDialog = () => {
    setIsCreateSupplierVisible(true);
  };

  const onCloseCreateSupplierDialog = () => {
    setIsCreateSupplierVisible(false);
    setAddSupplierLoading(false);
  };

  // check if supplier reloads after successful create
  const onAddSupplierOnModalPress = async (
    companyName: string,
    companyDetails: SupplierCompanyDetailRequest[],
    contacts: Contact[] | null
  ) => {
    setAddSupplierLoading(true);
    if (
      !companyName ||
      !containsAlphabetsWithSpacesAndDashes(companyName)
    ) {
      snackBar.show({
        severity: 'error',
        message: 'Please provide proper Company name'
      });
      setAddSupplierLoading(false);
      return;
    }

    const response = unwrapResult(
      await dispatch(
        supplierActions.createSupplierThunk({
          company_name: companyName,
          company_details: companyDetails,
          contacts
        })
      )
    );
    if (response.success) {
      snackBar.show({ severity: 'success', message: response.message });
      onCloseCreateSupplierDialog();
      getSupplierData();
    } else {
      snackBar.show({ severity: 'error', message: response.message });
    }
    setAddSupplierLoading(false);
  };

  const handleChange = (event: CustomInputEvent) => {
    setSearchText(event.target.value);
  };

  const onSearchClick = () => {
    getSupplierData();
  };

  const onKeyPress = (e: CustomKeyboardEvent) => {
    if (e.key === 'Enter') {
      getSupplierData();
    }
  };

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="flex-end"
      >
        <Typography color="textPrimary" gutterBottom variant="h3">
          Suppliers
        </Typography>
        <Button
          onClick={onOpenCreateSupplierDialog}
          color="primary"
          variant="outlined"
          disabled={!canAddSuppliers}
        >
          <span className={classes.supplyicon} />
          CREATE SUPPLIER
        </Button>
      </Box>
      <Box mt={3}>
        <Card>
          <CardContent>
            <Grid alignItems="center" container spacing={2}>
              <Grid item lg={6} md={8} xs={8}>
                <Box width="100%">
                  <TextField
                    onChange={handleChange}
                    fullWidth
                    label="Search Supplier"
                    placeholder="Enter Supplier Name"
                    variant="outlined"
                    onKeyPress={onKeyPress}
                  />
                </Box>
              </Grid>
              <Grid alignItems="center" item xs={1}>
                <Button
                  onClick={onSearchClick}
                  color="primary"
                  variant="contained"
                  style={{ height: 56, width: sm ? 88 : md ? 100 : 200 }}
                >
                  Search
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <SupplierDialogForm
          loading={addSupplierLoading}
          isVisible={isCreateSupplierVisible}
          onSavePress={onAddSupplierOnModalPress}
          handleClose={onCloseCreateSupplierDialog}
        />
      </Box>
    </div>
  );
};

export default Toolbar;
